"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PenSize = void 0;
var React = __importStar(require("react"));
var sizes = [8, 12, 18, 24, 32];
function PenSize(props) {
    var value = props.value, onChange = props.onChange;
    return (React.createElement("div", null,
        React.createElement("div", { className: "d-flex p-2" }, sizes.map(function (s, idx) { return (React.createElement("div", { className: "cursor-pointer d-flex justify-content-center align-items-center", key: idx, style: {
                border: "1px solid " + (s === value ? "red" : "#eaeaea"),
                // flexBasis: `${100 / sizes?.length}%`,
                // flexGrow: 0,
                aspectRatio: "1/1",
                width: "34px",
                height: "100%"
                // width: 40, height: 40,
                // paddingTop: ((50-s)/2),
                // paddingLeft: ((50-s)/2)
            }, onClick: function () { return onChange(s); } },
            React.createElement("div", { style: {
                    borderRadius: "50%",
                    background: "black",
                    width: s,
                    height: s
                } }))); }))));
}
exports.PenSize = PenSize;
